import { initEnvironmentReact } from '../../../initEnvironmentReact'

export const addCdnToUrl = (path: string) => {
  const environmentReactCdn = initEnvironmentReact.CDN_URL === '${VITE_CDN_URL}' ? '' : initEnvironmentReact.CDN_URL
  const CDN = import.meta.env.VITE_CDN_URL || environmentReactCdn || ''

  return `${CDN}${path}`
}
